export const DataTypes = {
    MILLION: 'million',
    THOUSANDS: 'thousand',
    CURRENCY: 'one',
    MULTIPLES: 'multiples',
    PERCENT: 'percent',
    /**
     * @deprecated It will be removed in 6 months 09-15-2025. use Calendar instead
     * */
    DATE: 'date',
    YEAR: 'year',
    NUMBER: 'number',
    /**
     * @deprecated It will be removed in 6 months 09-15-2025. use Calendar instead
     * */
    DATE_RANGE: 'date-range',
} as const;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DataTypesValues = [...Object.values(DataTypes)] as const;
export type DataType = typeof DataTypesValues[number];
